import script from "./BasePlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./BasePlaceholder.vue?vue&type=script&setup=true&lang=js"

import "./BasePlaceholder.vue?vue&type=style&index=0&id=4e54099c&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e54099c"]])

export default __exports__